import { render, staticRenderFns } from "./OnairDescriptionNavigation.vue?vue&type=template&id=36b2c6e9&scoped=true&"
import script from "./OnairDescriptionNavigation.vue?vue&type=script&lang=js&"
export * from "./OnairDescriptionNavigation.vue?vue&type=script&lang=js&"
import style0 from "./OnairDescriptionNavigation.vue?vue&type=style&index=0&id=36b2c6e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2c6e9",
  null
  
)

component.options.__file = "OnairDescriptionNavigation.vue"
export default component.exports